import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.name !== null) {
      params.set("name", this.filters.advanced.name);
    }

    if (this.filters.advanced.status.length > 0) {
      this.filters.advanced.status.forEach((element) =>
        params.append("status", element)
      );
    }

    if (this.filters.advanced.emplOfficerId?.length > 0) {
      this.filters.advanced.emplOfficerId.forEach((element) =>
        params.append("emplOfficerId", element)
      );
    }

    if (this.filters.advanced.academyOfficerId?.length > 0) {
      this.filters.advanced.academyOfficerId.forEach((element) =>
        params.append("academyOfficerId", element)
      );
    }

    if (this.filters.advanced.telephone !== null) {
      params.set("telephone", this.filters.advanced.telephone);
    }

    if (this.filters.advanced.email !== null) {
      params.set("email", this.filters.advanced.email);
    }

    if (this.filters.advanced.countries.length > 0) {
      this.filters.advanced.countries.forEach((element) =>
        params.append("countryId", element)
      );
    }

    if (this.filters.advanced.legalStatus.length > 0) {
      this.filters.advanced.legalStatus.forEach((element) =>
        params.append("legalStatus", element)
      );
    }

    if (this.filters.advanced.gender.length > 0) {
      this.filters.advanced.gender.forEach((element) =>
        params.append("gender", element)
      );
    }

    if (this.filters.advanced.matchedCompanies.length > 0) {
      this.filters.advanced.matchedCompanies.forEach((element) =>
        params.append("matchedCompanies", element)
      );
    }

    if (this.filters.advanced.coursesEnrolled !== null) {
      params.set("coursesEnrolled", this.filters.advanced.coursesEnrolled);
    }

    if (this.filters.advanced.route !== null) {
      params.set("route", this.filters.advanced.route);
    }

    if (this.filters.advanced.sourceChannel !== null) {
      params.set("sourceChannel", this.filters.advanced.sourceChannel);
    }

    if (this.filters.advanced.coursesCompleted !== null) {
      params.set("coursesCompleted", this.filters.advanced.coursesCompleted);
    }

    if (this.filters.advanced.employabilities !== null) {
      params.set("employabilities", this.filters.advanced.employabilities);
    }

    if (this.filters.advanced.livelihoods !== null) {
      params.set("livelihoods", this.filters.advanced.livelihoods);
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    if (this.filters.advanced.exclude !== null) {
      params.set("exclude", this.filters.advanced.exclude);
    }

    if (this.filters.advanced.projects.length > 0) {
      this.filters.advanced.projects.forEach((element) =>
        params.append("projects", element)
      );
    }

    if (this.filters.advanced.isFavorite !== null) {
      params.append("isFavorite", this.filters.advanced.isFavorite);
    }

    if (
      this.filters.advanced.regDates != null &&
      this.filters.advanced.regDates.length > 0
    ) {
      const regStartDate = this.filters.advanced.regDates[0];
      const regEndDate = this.filters.advanced.regDates.at(-1);
      params.set("regStartDate", formatDateToIsoString(new Date(regStartDate)));
      params.set("regEndDate", formatDateToIsoString(new Date(regEndDate)));
    }

    if (this.filters.advanced.primaryLikedProfession !== null) {
      params.set(
        "primaryLikedProfession",
        this.filters.advanced.primaryLikedProfession
      );
    }

    if (this.filters.advanced.secondaryLikedProfession !== null) {
      params.set(
        "secondaryLikedProfession",
        this.filters.advanced.secondaryLikedProfession
      );
    }

    return params;
  },
};
